<template>
	<div class="commonModalBlo">
		<div class="commonModal modal modalBorder">
			<div class="commonTitle">
				问题反馈
			</div>

			<div class="commonCon">
				<el-form @submit.native.prevent :model="formData" ref="formDataRef" :rules="rules" label-width="auto"
					label-position="left" hide-required-asterisk>
					<el-form-item label="反馈信息" prop="content">
						<el-input ref="inputFocusRef" v-model="formData.content" type="textarea" resize="none"
							placeholder="填写反馈信息" class="widthPercentage height162"></el-input>
					</el-form-item>

					<el-form-item label="标注地址" class="smallFormItem">
						<div class="color_B9B">{{formData.address}}</div>
					</el-form-item>

					<el-form-item label="标注截图" style="margin-bottom: 8px !important;">
						<img :src="formData.markImgBase64" alt=""
							class="markImgBase64Sty displayB border borderRadius4">
					</el-form-item>

					<el-form-item label=" " class="smallFormItem">
						<div class="color_B9B fontSize14 lineHeight20">
							注意：反馈过程中，系统将截取界面以便直观处理问题。
						</div>
					</el-form-item>
				</el-form>
			</div>

			<div class="buttonBlo buttonBloP">
				<el-button @click="submitHandle()" type="primary" :loading="loading">{{getSureText('提交')}}</el-button>
				<el-button @click="cancel()">{{getCancelText()}}</el-button>
				
				<!-- <div class="left" @click="submitHandle()"></div> -->
				<!-- <div class="rig" @click="cancel()"></div> -->
			</div>
		</div>
	</div>
</template>

<script setup>
	import {
		getSureText,
		initThemeImg,
		getCancelText,
		setMessageQueue
	} from '@/utils/common.js'
	import useUserStore from '@/store/modules/user.js'

	import {
		sysfeedbackrecordSubmitFeedback
	} from '@/api/systemNotification'

	// 主题色--默认亮色
	const theme = computed(() => {
		return useUserStore().theme
	})
	// 配置数据
	const userConfigData = computed(() => {
		return useUserStore().userConfigData
	})

	const {
		proxy
	} = getCurrentInstance()
	const props = defineProps({
		propsObj: {
			type: Object,
			default: () => {}
		}
	})
	const formData = ref({})
	const rules = {
		content: [{
			required: true,
			message: '反馈信息不能为空',
			trigger: ['change', 'blur']
		}]
	}
	const inputFocusRef = ref(null)
	const loading = ref(false)
	
	watch(() => props.propsObj, val => {
		if (val.loadingReset) {
			loading.value = false
		}
	
		// console.log(val, loading.value, 'val propsObj watch')
	}, {
		deep: true,
		immediate: true
	})

	function cancel() {
		proxy.$emit('cancelHandle')
	}

	function submitHandle() {
		proxy.$refs.formDataRef.validate(valid => {
			if (valid) {
				console.log(formData.value, 'formData.value sure')
				proxy.$emit('sureHandle', formData.value)
				// 弹窗 可直接禁用按钮
				// loading.value = true
			} else {
				return false
			}
		})
	}

	// 点击回车键
	function keyDown(e) {
		let shortcutModelArr = userConfigData.value.shortcutModelArr
		console.log(e, 'e keyDown document.activeElement', document.activeElement)
		const activeElement = document.activeElement
		const tagName = activeElement.tagName // BODY 标签大写  按钮文案 textContent
		if (activeElement && tagName !== 'BODY') {
			// 有焦点时 enter键或者esc时失去焦点
			if (e.key === 'Enter' || e.key === 'Escape') {
				// 失去焦点
				activeElement.blur();
			}

			if (e.key === 'Tab') {
				if (activeElement.textContent === '⌜取消⌟') {
					e.preventDefault();

					// 重新设置焦点到 textarea
					const textarea = document.querySelector('textarea');
					if (textarea) {
						textarea.focus();
					}
				}
				console.log(document.activeElement, activeElement.textContent,
					'document.activeElement activeElement.textContent')
			}
		} else {
			if (e.key === 'Escape') {
				if (shortcutModelArr.includes(3)) {
					cancel()
				}
			}
		}

		// shift+enter快捷键提交
		if (e.shiftKey && e.key === 'Enter') {
			if (shortcutModelArr.includes(1)) {
				e.preventDefault();
				submitHandle()
				e.stopPropagation();
			}
		}
		
		// tab加日志
		if (e.key === 'Tab') {
			console.log(e, 'e keyDown Tab document.activeElement', document.activeElement)
		}
	}

	onMounted(() => {
		// 当前是弹窗
		useUserStore().isModal = true

		proxy.$nextTick(() => {
			formData.value = props.propsObj
			proxy.$refs.formDataRef.clearValidate()
			// 绑定监听事件
			window.addEventListener('keydown', keyDown, true)
			proxy.$refs.inputFocusRef.focus()
			console.log(formData.value, props.propsObj, 'formData.value, props.propsObj')
		})
	})

	onUnmounted(() => {
		useUserStore().isModal = false
		window.removeEventListener('keydown', keyDown, true)
	})
</script>

<style lang="scss" scoped>
	@import "@/styles/handle.scss";

	.commonModalBlo .modal {
		width: 800px;
		height: 622px;
		// height: unset;
		// min-height: 520px;
	}

	::-webkit-scrollbar {
		display: none;
	}

	.markImgBase64Sty {
		width: 328px; // 286px => 328px
		// height: auto;
		height: 156px; // 150px => 156px
		object-fit: scale-down;
	}

	.el-button {
		width: 80px;
	}

	.el-button+.el-button {
		margin-left: 0;
	}
</style>